/**
 * @generated SignedSource<<8647647958b2fd86d380e2dba1d610d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InstructorHeaderFragment_staffProfile$data = {
  readonly id: string;
  readonly instructorDepartmentProfile: {
    readonly headline: string | null | undefined;
  };
  readonly user: {
    readonly fullName: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"InstructorPhotoFragment_staffProfile">;
  readonly " $fragmentType": "InstructorHeaderFragment_staffProfile";
};
export type InstructorHeaderFragment_staffProfile$key = {
  readonly " $data"?: InstructorHeaderFragment_staffProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"InstructorHeaderFragment_staffProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "facilitySlug"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "InstructorHeaderFragment_staffProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InstructorPhotoFragment_staffProfile"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StaffUser",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "facilitySlug",
          "variableName": "facilitySlug"
        }
      ],
      "concreteType": "InstructorDepartmentProfile",
      "kind": "LinkedField",
      "name": "instructorDepartmentProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headline",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StaffProfile",
  "abstractKey": null
};

(node as any).hash = "a32a594eb3c66f105707a096cdc502d1";

export default node;
